import { Injectable } from '@angular/core';
import { BaseAPIClass } from '@app/core';
import { HttpClient, HttpBackend } from '@angular/common/http';
import { environment } from '@env/environment.prod';
import { Paginated } from '../model/paginated.model';
import { Observable } from 'rxjs';
import { Client } from '../model/client.model';

@Injectable({
  providedIn: 'root'
})
export class PagoIngresoService extends BaseAPIClass {
  // baseUrl = environment.serverBaseUrl;
  baseUrl = environment.serverBaseUrl;
  public isLoading = false;
  constructor(protected httpClient: HttpClient, handler: HttpBackend) {
    super(httpClient);
    this.httpClient = new HttpClient(handler);
    this.baseUrl = this.baseUrl + '/pago-ingresos';
  }
 

  

  /*enableClient(id: any) {

  }*/
}
